<template>
  <v-app>
    <!-- Site-wide banner set from Admin → System -->
    <div v-if="banner && !maintenanceBlocks" class="mz-banner">{{ banner }}</div>

    <!-- Maintenance mode: blocks signed-in non-admins -->
    <div v-if="maintenanceBlocks" class="mz-maint">
      <div class="mz-maint-card">
        <div class="mz-maint-ico">🛠</div>
        <h2>Muzilly is taking a short break</h2>
        <p>{{ maintenance.message || "We're making improvements and will be right back." }}</p>
      </div>
    </div>
    <router-view v-else />

    <!-- Outside router-view so audio keeps playing across route changes -->
    <GlobalMiniPlayer />
    <!-- Floating mini player for a video / episode you left while it was playing -->
    <GlobalMiniVideo />
    <!-- Live "new notification" toasts + unread count in the tab title -->
    <NotificationToaster />
  </v-app>
</template>

<script>
import GlobalMiniPlayer from "@/components/GlobalMiniPlayer.vue";
import GlobalMiniVideo from "@/components/GlobalMiniVideo.vue";
import NotificationToaster from "@/components/NotificationToaster.vue";
import { auth, db } from "@/firebase";
import { onAuthStateChanged } from "firebase/auth";
import { doc, onSnapshot } from "firebase/firestore";

export default {
  name: "App",
  components: { GlobalMiniPlayer, GlobalMiniVideo, NotificationToaster },
  data() { return { cfg: {}, myType: "", signedIn: false }; },
  computed: {
    banner() { return this.cfg.banner || ""; },
    maintenance() { return this.cfg.maintenance || {}; },
    // Admins always get in so they can switch it back off.
    maintenanceBlocks() { return this.signedIn && !!this.maintenance.enabled && this.myType !== "admin"; },
  },
  created() {
    this._subs = [];
    this._off = onAuthStateChanged(auth, (u) => {
      this._subs.forEach((s) => s()); this._subs = [];
      this.signedIn = !!u; this.myType = ""; this.cfg = {};
      if (!u) return;
      this._subs.push(onSnapshot(doc(db, "user", u.uid), (s) => { const d = s.data() || {}; this.myType = String(d.type || d.role || "").toLowerCase(); }, () => {}));
      this._subs.push(onSnapshot(doc(db, "platformConfig", "app"), (s) => { this.cfg = s.data() || {}; }, () => {}));
    });
  },
  beforeDestroy() { if (this._off) this._off(); (this._subs || []).forEach((s) => s()); },
};
</script>

<style>
body {
  margin: 0;
  font-family: "Roboto", sans-serif;
}
.mz-banner {
  position: sticky; top: 0; z-index: 9999; text-align: center; padding: 8px 14px;
  background: #d48c1c; color: #0c0a0e; font-size: 13px; font-weight: 600;
}
.mz-maint { min-height: 100vh; display: flex; align-items: center; justify-content: center; background: #0c0a0e; color: #f5f0e8; padding: 24px; }
.mz-maint-card { max-width: 420px; text-align: center; }
.mz-maint-ico { font-size: 44px; margin-bottom: 8px; }
.mz-maint-card h2 { font-weight: 500; margin: 0 0 8px; }
.mz-maint-card p { color: rgba(245, 240, 232, 0.6); line-height: 1.5; }
</style>